import { Controller } from "@hotwired/stimulus";

// The optional inflow overlay (including savings withdrawals) never changes the main scale. Apply the
// checkbox to both lazy frames and categorization-triggered replacements.
export default class extends Controller {
  static targets = ["compareMoneyIn", "monthlyScroll"];
  declare readonly compareMoneyInTarget: HTMLInputElement;
  private monthlyScrollObserver: IntersectionObserver | null = null;

  monthlyScrollTargetConnected(element: HTMLElement) {
    element.scrollLeft = element.scrollWidth;
    // Hidden tabs have no scrollable layout yet. Align once when shown, then
    // leave the user's scroll position alone.
    this.monthlyScrollObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        element.scrollLeft = element.scrollWidth;
        this.monthlyScrollObserver?.disconnect();
      }
    });
    this.monthlyScrollObserver.observe(element);
  }

  monthlyScrollTargetDisconnected() {
    this.monthlyScrollObserver?.disconnect();
    this.monthlyScrollObserver = null;
  }

  connect() {
    this.refresh();
  }

  refresh() {
    for (const overlay of this.element.querySelectorAll<HTMLElement | SVGElement>("[data-analysis-income]")) {
      // SVG does not implement HTMLElement.hidden.
      overlay.toggleAttribute("hidden", !this.compareMoneyInTarget.checked);
    }
  }
}
